// Libraries
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import User from 'utils/user.util';

function Logout({ setToken, setProperty }) {
    let navigation = useNavigate();
    useEffect(() => {
        // Unset token
        setToken(null);
        setProperty(null);
        User.clear();

        // Send to login
        navigation('/');
    }, []);

    return <></>;
}

export default Logout;
